import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Items14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path d='M10 4.75H4V3.25H10V4.75Z' fill='currentColor' />
    <path
      d='M5 11C5.55228 11 6 10.5523 6 10C6 9.44771 5.55228 9 5 9C4.44772 9 4 9.44771 4 10C4 10.5523 4.44772 11 5 11Z'
      fill='currentColor'
    />
    <path
      d='M10 10C10 10.5523 9.55228 11 9 11C8.44772 11 8 10.5523 8 10C8 9.44771 8.44772 9 9 9C9.55228 9 10 9.44771 10 10Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.25 1.5C1.25 0.809644 1.80964 0.25 2.5 0.25H11.5C12.1904 0.25 12.75 0.809644 12.75 1.5V6.5C12.75 6.67778 12.7129 6.84689 12.646 7C12.7129 7.15312 12.75 7.32222 12.75 7.5V12.5C12.75 13.1904 12.1904 13.75 11.5 13.75H2.5C1.80964 13.75 1.25 13.1904 1.25 12.5V7.5C1.25 7.32222 1.28711 7.15312 1.35401 7C1.28711 6.84688 1.25 6.67778 1.25 6.5V1.5ZM2.75 6.25H11.25V1.75H2.75V6.25ZM2.75 7.75V12.25H11.25V7.75H2.75Z'
      fill='currentColor'
    />
  </Svg>
);

Items14.displayName = 'Items14';
export default Items14;
